export const SYSTEM_TIPS = [
  '工作台按权限聚合待办、公告、项目动态和客户跟进提醒，每天先看待办中心，再跳转处理业务。',
  '“本周关键节点”支持列表和日历视图；排期冲突或临近节点，用日历视图更容易看出节奏。',
  '工作台风险预警会汇总逾期和即将逾期的任务、项目阶段、需求，点击卡片可反查业务源头。',
  '顶部消息铃铛会同步消息中心未读数；带跳转的通知点击“查看”会先标记已读，再进入关联业务。',
  '顶部公告条如果配置了业务跳转，会直接进入对应页面；没有跳转时进入公告详情。',
  '详情抽屉右上角可切换全屏，查看长表单、附件和评论时比窄抽屉更舒服。',
  '需求被指派后，相关负责人需要先“响应”再开始处理；有条件响应可顺延 1-3 天并留下原因。',
  '需求评论可 `@` 需求相关人员或管理员；回复某条评论时，系统会优先提醒被回复人。',
  '需求详情的图片、PDF、Word、Excel 等附件可在线预览；PowerPoint 或不支持格式则下载原文件。',
  '客户跟进支持列表、看板、时间线和样机跟踪；复盘销售节奏时优先看时间线和样机反馈。',
  '录入客户名称时系统会做查重提示，可看到当前负责人、部门、公海状态和上级客户线索。',
  '下次跟进时间会进入后续提醒；长期无跟进动态的客户会先提醒负责人，达到阈值后自动转入公海。',
  '公海客户可自助领取或由主管分配；转入公海后原负责人存在冷却期，避免刚释放又被立即领回。',
  '问题类别会带出默认归属部门；提交前确认类别，比后续转派更省时间。',
  '问题遇到外部卡点可先“挂起”，恢复后继续处理；处理人标记已解决后，由提交人确认关闭。',
  '问题关闭后 72 小时内提交人可重新打开，适合解决方案未生效时继续追踪。',
  '文档中心支持拖拽批量上传；进入文件夹后新建目录或上传文件会默认继承父级权限。',
  '周报月报支持卡片和表格视图；提交并抄送后，详情页可回看内容和审批/抄送上下文。',
  '审批按待办、我的申请、抄送我的和全部审批拆分；转批、加抄送、驳回等操作只在有权限时展示。',
  '管理员可拖拽配置工作台区块、恢复角色默认布局；调整后建议用管理员和普通用户各看一次。',
  '操作日志支持按人、模块、动作、时间筛选并导出 CSV/Excel/JSON，适合追查配置变更和误操作。',
] as const;

export type SystemTip = (typeof SYSTEM_TIPS)[number];
